import axios from 'axios'
import webAulaConfig from '../config/webAula'

const webAula = {}

webAula.obterToken = (host) => {
	const credenciais = (host === 1)
		? { name: 'SIA', login: 'SIA', pass: 'ApIP0RT@LPr&$eNc1@LSIA' }
		: { name: 'SIA', login: 'SIA', pass: 'ApIGRADu@cA0&@DSIA' }

	const endpoint = (host === 1)
		? '/api/portal/Auth/Index'
		: '/api/graduacao/Auth/Index'

	return axios.post(webAulaConfig.SERVICO_WEBAULA + endpoint, credenciais)
}

webAula.obterAluno = (cpf, host, token) => {
	const config = {
		headers: {
			Authorization: token
		}
	}
	const endpoint = (host === 1)
		? '/api/portal/User/GetStudentDataByEnrolment?cpf=' + cpf
		: '/api/graduacao/User/GetStudentDataByEnrolment?cpf=' + cpf

	return axios.get(webAulaConfig.SERVICO_WEBAULA + endpoint, config)
}

webAula.obterDocente = (cpf, host, token) => {
	const config = {
		headers: {
			Authorization: token
		}
	}
	const endpoint = (host === 1)
		? '/api/portal/User/GetInstructorDataByCpf?cpf=' + cpf
		: '/api/graduacao/User/GetInstructorDataByCpf?cpf=' + cpf

	return axios.get(webAulaConfig.SERVICO_WEBAULA + endpoint, config)
}

export { webAula }
